<template>
  <div class="wallet-container">
    <!-- 余额卡片 -->
    <div class="balance-card">
      <div class="balance-header">
        <div class="balance-info">
          <p class="balance-label">总余额</p>
          <h2 class="balance-amount">
            {{ userInfo.accountBalance + userInfo.blockBalance }}
          </h2>
        </div>
      </div>

      <div class="balance-details">
        <div class="balance-item">
          <span class="label">可用余额</span>
          <span class="amount">{{ userInfo.accountBalance }}</span>
        </div>
        <div class="balance-item">
          <span class="label">冻结余额</span>
          <span class="amount">{{ userInfo.blockBalance }}</span>
        </div>
      </div>
    </div>

    <!-- 快捷操作 -->
    <div class="quick-actions">
      <van-grid :column-num="4" :border="false" style="display: flex; justify-content: space-around">
        <van-grid-item v-for="action in quickActions" :key="action.id" :icon="action.icon" :text="action.text"
          @click="onActionClick(action)" />
      </van-grid>
    </div>

    <!-- 交易记录 -->
    <div class="transaction-section">
      <div class="section-header">
        <h3>最新资金流水</h3>
        <van-button type="primary" size="mini" @click="viewAllTransactions">
          查看更多
        </van-button>
      </div>

      <!-- 筛选标签 -->
      <!-- <van-tabs v-model:active="activeTab" @change="onTabChange">
        <van-tab title="全部" name="all"></van-tab>
        <van-tab title="收入" name="income"></van-tab>
        <van-tab title="支出" name="expense"></van-tab>
      </van-tabs> -->

      <!-- 交易列表 -->
      <div class="transaction-list">
        <van-cell-group>
          <van-cell v-for="(transaction, index) in transactions" title-class="cell-title" :key="index"
            :label="transaction.createdAt" :value="'￥' + transaction.ppAmount + ''" :value-class="transaction.type === 'income' ? 'income-amount' : 'expense-amount'
              ">
            <template #title>
              <van-tag v-if="transaction.tranType == 1" type="primary">充值</van-tag>
              <van-tag v-if="transaction.tranType == 2" type="success">提现</van-tag>
              <span class="custom-title">{{
                " 订单号:" + transaction.depositId
              }}</span>
            </template>
          </van-cell>
        </van-cell-group>
      </div>
    </div>

    <!-- 充值弹窗 -->
    <van-popup v-model:show="showRechargePopup" position="bottom" :style="{ height: '90%' }">
      <div class="recharge-container">
        <div class="recharge-header">
          <div class="header-title">充值金额</div>
          <van-icon name="cross" @click="showRechargePopup = false" />
        </div>

        <!-- 金额输入区域 -->
        <div class="amount-input">
          <div class="amount-field">
            <span class="currency">¥</span>
            <van-field v-model="rechargeAmount" type="number" placeholder="请输入金额" :border="false" />
          </div>
          <div class="balance-info">余额：¥{{ userInfo.accountBalance }}</div>
        </div>

        <!-- 快捷金额选择 -->
        <div class="amount-options">
          <van-button v-for="amount in rechargeOptions" :key="amount" size="small" type="default"
            @click="selectRechargeAmount(amount)">
            ¥{{ amount }}
          </van-button>
        </div>

        <!-- 支付方式选择 -->
        <div class="payment-method">
          <van-radio-group v-model="payMethod">
            <div class="method-item">
              <van-image width="24" height="24" :src="require('@/assets/zhifubao.png')" />
              <span class="method-name">支付宝(<span style="font-weight: bold">请在浏览器内打开网页支付<van-icon name="question" color="#000" size="18px" style="margin-right:4px" @click="alipayTipClick"/></span>)</span>
              <van-radio name="alipay"></van-radio>
            </div>
            <br />
            <div class="method-item">
              <van-image width="24" height="24" :src="require('@/assets/weixin.png')" />
              <span class="method-name">微 信(<span style="font-weight: bold">请在微信内打开网页支付<van-icon name="question" color="#000" size="18px" style="margin-right:4px" @click="weixinTipClick"/></span>)</span>
              <van-radio name="wechat"></van-radio>
            </div>
          </van-radio-group>
        </div>

        <!-- 充值须知 -->
        <div class="recharge-notice">
          <div @click="startChat()" style="
              text-decoration: underline;
              color: #1989fa;
              margin-bottom: 10px;
            ">
            <van-icon size="20" name="chat" />点击咨询客服
          </div>
          <div class="notice-title">充值须知</div>
          <div class="notice-item">1. 单笔限额1-3000元；</div>
          <div class="notice-item">2. 账号违规资金转移套现将被封号处理；</div>
          <div class="notice-item">3. 禁止未成年人充值消费。</div>
        </div>

        <!-- 充值按钮 -->
        <div class="submit-button">
          <van-button type="primary" block @click="confirmRecharge" loading-text="充值中..."
            :loading="loading">确认充值</van-button>
        </div>
      </div>
    </van-popup>

    <!-- 提现弹窗 -->
    <van-popup v-model:show="showWithdrawPopup" position="bottom" :style="{ height: '90%' }">
      <div class="withdraw-container">
        <div class="withdraw-header">
          <div class="header-title">提现到</div>
          <van-icon name="cross" @click="showWithdrawPopup = false" />
        </div>

        <!-- 支付宝选择区域 -->
        <div class="payment-method">
          <van-radio-group v-model="payChecked">
            <div class="method-item">
              <van-image width="24" height="24" :src="require('@/assets/zhifubao.png')" />
              <span class="method-name">支付宝(<span style="font-weight: bold">请在浏览器内打开网页支付<van-icon name="question" color="#000" size="18px" style="margin-right:4px" @click="alipayTipClick"/></span>)</span>
              <van-radio name="1"></van-radio>
            </div>
            <br />
            <div class="method-item">
              <van-image width="24" height="24" :src="require('@/assets/weixin.png')" />
              <span class="method-name">微信(<span style="font-weight: bold">请在微信内打开网页支付<van-icon name="question" color="#000" size="18px" style="margin-right:4px" @click="weixinTipClick"/></span>)</span>
              <van-radio name="2"></van-radio>
            </div>
          </van-radio-group>
        </div>

        <!-- 账号输入区域 -->
        <div class="account-input">
          <div v-show="payChecked == 1">
            <div class="input-label">支付宝账号</div>
            <van-field v-model="withdrawAccount" placeholder="必须填写本人支付宝账号" :border="false" />
          </div>
          <div class="input-label">真实姓名</div>
          <van-field v-model="withdrawName" placeholder="必须填写本人真实姓名" :border="false" />
        </div>

        <!-- 个人微信收款码 -->
        <!-- <div v-show="payChecked == 2" class="wechat-pay-code">
          <span>个人收款码</span>
          <van-uploader
            v-model="fileList"
            :after-read="afterRead"
            accept="image/*"
            :max-count="1"
          />
        </div> -->

        <!-- 金额输入区域 -->
        <div class="amount-input">
          <div class="input-label">提现金额</div>
          <div class="amount-field">
            <span class="currency">¥</span>
            <van-field v-model="withdrawAmount" type="number" placeholder="请输入提现金额" :border="false" />
          </div>
          <div class="balance-info">
            可用余额：¥{{ userInfo.accountBalance }}
          </div>
        </div>

        <!-- 服务费 -->
        <div class="voucher-section">
          <van-cell title="服务费" :value="'￥' + serveMoney" />
        </div>

        <!-- 提现说明 -->
        <div class="withdraw-notice">
          <div class="notice-item">
            1. 每日默认提现3次，系统会根据交易数据自动调整外次数；
          </div>
          <!-- <div class="notice-item">
            2. 微信提现需要上传个人收款码，如果已存在会自动显示；
          </div> -->
          <div class="notice-item">
            2. 提现会产生2%手续费，最低2元，向上取整；
          </div>
          <div class="notice-item">
            3. 支付宝提现实时到账，微信提现时间1-5个工作日内到账。
          </div>
        </div>

        <!-- 提现按钮 -->
        <div class="submit-button">
          <van-button type="primary" block @click="confirmWithdraw" loading-text="提现中..."
            :loading="loading">确认提现</van-button>
        </div>
      </div>
    </van-popup>

<van-popup :style="{ height: '70%', width: '100%' }" v-model:show="noticeShow">
      <div v-html="noticeData"></div>
    </van-popup>
  </div>
</template>

<script>
import { showToast, showDialog } from "vant";
import request from "@/utils/request";
import QRCode from "qrcode";
import CryptoJS from "crypto-js";
import wx from "weixin-js-sdk";
export default {
  name: "WalletPage",
  data() {
    return {
      noticeShow: false,
      noticeData: null,
      appid: "wx7f7a74f218219cbc",
      agreeCheck: null,
      loading: false,
      totalBalance: "",
      availableBalance: "",
      frozenBalance: "",
      balanceVisible: true,
      activeTab: "all",
      showRechargePopup: false,
      showWithdrawPopup: false,
      tranType: null,
      payChecked: "1",
      payMethod: "alipay", // 支付方式，默认支付宝
      rechargeAmount: "",
      withdrawAmount: "",
      withdrawAccount: "",
      withdrawName: "",
      rechargeOptions: [100, 500, 1000, 2000],
      maxRechargeAmt: 3000,
      quickActions: [
        { id: 1, icon: "gold-coin-o", text: "充值", action: "recharge" },
        { id: 2, icon: "cash-back-record", text: "提现", action: "withdraw" },
      ],
      transactions: [],
      userInfo: {},
      pageNum: 1,
      zijinForm: {},
      fileList: [],

      //微信扫码支付
      qrCodeImage: "",
      showQrCodePopup: false,
      pollingTimer: null,
      currentOrderId: "",

      payCodeUrl: null,
    };
  },
  created() {
    // 处理微信授权回调
    this.handleWechatAuthCallback();

    this.$store.dispatch("user/getUserInfo").then((res) => {
      if (res.code == 200) {
        this.userInfo = res.data;
      }
    });
    this.pageNum = 1;
    this.getList();
  },
  computed: {
    serveMoney() {
      if (this.withdrawAmount.length > 0) {
        const feeAmt = parseFloat(this.withdrawAmount) * 0.02;
        return feeAmt > 2 ? feeAmt.toFixed(2) : 2;
      } else {
        return 0;
      }
    },
  },
  methods: {
    weixinTipClick() {
       request.get("/front/chat/keywords", { params: { type: 5 } }).then((res) => {
      if (res.code == 200) {
        this.noticeClick(res.data[0])
      }
    });
    },
    alipayTipClick() {
       request.get("/front/chat/keywords", { params: { type: 6 } }).then((res) => {
      if (res.code == 200) {
        this.noticeClick(res.data[0])
      }
    });
    },
    noticeClick(data) {
      this.noticeData = data.content;
      this.noticeData = this.processHTMLWithStyledImages(this.noticeData);
      this.noticeShow = true;
    },
    extractAndStyleImages(htmlString) {
      // 匹配所有img标签的正则表达式
      const imgRegex = /<img[^>]+src="([^">]+)"[^>]*>/g;
      const images = [];
      let match;

      // 提取所有img标签
      while ((match = imgRegex.exec(htmlString)) !== null) {
        images.push({
          originalTag: match[0], // 原始img标签
          src: match[1], // 图片地址
          index: match.index, // 在字符串中的位置
        });
      }

      return images;
    },
    processHTMLWithStyledImages(htmlString) {
      // 提取所有图片
      const images = this.extractAndStyleImages(htmlString);
      let processedHTML = htmlString;

      // 为每个img标签添加样式
      images.forEach((img) => {
        const styledImgTag = `<img src="${img.src}" style="max-width: 100%; height: auto;" alt="饰品图片">`;
        processedHTML = processedHTML.replace(img.originalTag, styledImgTag);
      });

      return processedHTML;
    },
    startChat() {
      window.open("https://work.weixin.qq.com/kfid/kfc0afede0891281246");
    },
    getList() {
      request
        .get("/front/capital/flow/list", {
          params: {
            pageNum: this.pageNum,
            pageSize: 10,
            depositId: this.zijinForm.depositId,
            status: this.zijinForm.status,
            chlTransId: this.zijinForm.chlTransId,
            tranType: this.zijinForm.tranType,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            console.log(res);
            this.transactions = res.rows;
          }
        });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    toggleBalanceVisibility() {
      this.balanceVisible = !this.balanceVisible;
    },
    onActionClick(action) {
      switch (action.action) {
        case "recharge":
          this.showRechargePopup = true;
          this.tranType = 1;
          break;
        case "withdraw":
          this.showWithdrawPopup = true;
          this.tranType = 2;
          break;
        case "records":
          this.viewAllTransactions();
          break;
        case "service":
          showToast("正在为您转接客服...");
          break;
      }
    },
    onTabChange(name) {
      this.activeTab = name;
    },
    viewAllTransactions() {
      this.$router.push("/paymentHistory");
    },
    selectRechargeAmount(amount) {
      this.rechargeAmount = amount.toString();
    },
    //充值
    confirmRecharge() {
      if (!this.rechargeAmount || this.rechargeAmount <= 0) {
        showToast("请输入有效的充值金额");
        return;
      }

      showDialog({
        title: "确认充值",
        message: `确认充值 ${this.rechargeAmount} 元吗？`,
        showCancelButton: true,
      }).then(async () => {
        try {
          if (this.payMethod == "wechat") {
            if (!this.isInWeixin()) {
              showToast("请在微信内打开网页支付");
              return;
            }
            this.loading = true;
            this.loadingText = "正在跳转微信页面提现..."
            if (this.userInfo.openId) {
              this.processWechatPayment({
                openid: this.userInfo.openId,
                amount: this.rechargeAmount
              })
            } else {
              this.onBridgeReady();
            }
          } else {
            if (this.isInWeixin()) {
              showToast("请在浏览器内打开网页支付");
              return;
            }
            this.loading = true;
            this.loadingText = "正在跳转支付宝页面提现..."
            this.alipayChargePay();
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false;
          this.showRechargePopup = false;
        }
      });
    },
    isInWeixin() {
      const judgeIfWeXin = typeof WeixinJSBridge == "undefined";
      return !judgeIfWeXin;
    },
    generateNonceStr() {
      return Math.random().toString(36).substring(2, 34);
    },
    //微信内核浏览器支付
    onBridgeReady() {
      // 可以在state参数中传递自定义数据，微信会原样返回
      const stateData = {
        amount:
          this.tranType == 1 ? this.rechargeAmount : this.withdrawAmount,
        //1是充值 2是提现
        tranType: this.tranType,
        realName: this.tranType == 2 ? this.withdrawName : "",
      };

      // 将state数据编码为JSON字符串并进行URL编码
      const stateParam = encodeURIComponent(JSON.stringify(stateData));
      // 使用正确的重定向URL格式
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appid
        }&redirect_uri=${encodeURIComponent(
          "https://www.ppstandoff2.com/wallet"
        )}&response_type=code&scope=snsapi_base&state=${stateParam}#wechat_redirect`;
    },
    // 处理微信授权回调
    async handleWechatAuthCallback() {
      const url = new URL(window.location.href);
      const code = url.searchParams.get("code");
      const state = url.searchParams.get("state");
      console.log(`code=${code}, state=${state}`)
      if (code) {
        try {
          // 先解码，再解析JSON
          const decodedState = decodeURIComponent(state);
          const stateData = JSON.parse(decodedState);
          console.log(stateData);
          const res = await request.get("/front/auth/wechat/auth/callback", {
            params: { code },
          });
          this.userinfo.openId = res.data;
          if (stateData.tranType == 1) { //充值
            //执行微信支付逻辑 
            stateData.openid = res.data
            this.processWechatPayment(stateData);
          } else if (stateData.tranType == 2) { //提现
            // 准备执行微信支付逻辑
            stateData.openid = res.data
            this.processWechatTiXIAN(stateData);
          }
        } catch (error) {
          console.error("解析state参数失败:", error);
          showToast("参数解析失败");
        }
        const cleanUrl = url.origin + url.pathname;
        window.history.replaceState({}, document.title, cleanUrl);
      }
    },

    // 处理微信支付
    async processWechatPayment(stateData) {
      try {
        // 调用微信支付
        this.invokeWechatPay({
          openid: stateData.openid,
          amount: stateData.amount,
          payType: 1,
          payScene: 1,
          description: "账户充值",
        });
      } catch (error) {
        showToast("支付处理失败，请重试");
      }
    },
    // 处理微信提现
    async processWechatTiXIAN(stateData) {
      try {
        this.invokeWechatPayTixian({
          openid: stateData.openid,
          amount: stateData.amount,
          payType: 1,
          description: "账户提现",
          realName:
            Number(stateData.amount) >= 2000 ? stateData.realName : "",
        });
      } catch (error) {
        showToast("提现处理失败，请重试");
      }
    },

    generate32BitRandom() {
      const chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      const maxPos = chars.length;
      let result = "";

      for (let i = 0; i < 32; i++) {
        result += chars.charAt(Math.floor(Math.random() * maxPos));
      }

      return result;
    },
    // 调用微信支付
    async invokeWechatPay(payData) {
      const res = await request.post("/front/pay/create", payData);
      if (res.code == 200) {
        if (typeof WeixinJSBridge === "undefined") {
          showToast("请在微信中打开");
        } else {

          WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            {
              appId: res.data.payParams.appId,
              timeStamp: res.data.payParams.timeStamp,
              nonceStr: res.data.payParams.nonceStr,
              package: res.data.payParams.packageVal,
              signType: res.data.payParams.signType,
              paySign: res.data.payParams.paySign,
            },
            (res) => {
              if (res.err_msg === "get_brand_wcpay_request:ok") {
                this.pollPaymentResult(`/front/pay/status/1/1/${res.data.currentOrderId}`, 10, 2000);
              } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
                showToast('用户取消支付');
              } else {
                showToast('支付失败');
              }
            }
          );
        }
      }
    },
    //调用微信提现
    async invokeWechatPayTixian(payData) {
      const res = await request.post("/front/pay/transfer", payData);
      if (res.code == 200) {
        const res2 = await request.get("/front/auth/getTicket");
        // console.log("票据是，", res2);
        let nonceStr;
        let jsapi_ticket;
        let timeStamp;
        let signature;
        if (res2.code == 200) {
          nonceStr = this.generateNonceStr();
          jsapi_ticket = res2.data.jsapi_ticket;
          timeStamp = +new Date();
          signature = this.generateWechatSignature(
            jsapi_ticket,
            nonceStr,
            timeStamp,
            "https://www.ppstandoff2.com/wallet"
          );
          // console.log("签名是，", signature);
        }

        //   检测当前浏览器环境是否为微信内置浏览器
        //  @returns {boolean} true-是微信环境, false-不是微信环境
        //
        // 获取用户代理字符串并转换为小写
        const ua = navigator.userAgent.toLowerCase();

        // 检测用户代理中是否包含微信特有的标识符
        let isWechatBrowser = ua.indexOf("micromessenger") !== -1;

        // 使用示例
        if (isWechatBrowser) {
          // eslint-disable-next-line no-undef
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: this.appid, // 必填，服务号的唯一标识
            nonceStr: nonceStr,
            signature: signature,
            timestamp: timeStamp,
            jsApiList: ["requestMerchantTransfer"], // 必填，需要使用的JS接口列表
          });
          // eslint-disable-next-line no-undef
          wx.ready(function () {
            // eslint-disable-next-line no-undef
            wx.checkJsApi({
              jsApiList: ["requestMerchantTransfer"],
              success: function (wxResult) {
                if (wxResult.checkResult["requestMerchantTransfer"]) {
                  WeixinJSBridge.invoke(
                    "requestMerchantTransfer",
                    {
                      mchId: res.data.mchId,
                      appId: res.data.appId,
                      package: res.data.packageInfo,
                    },
                    function (res) {
                      if (res.err_msg === "requestMerchantTransfer:ok") {
                        this.pollPaymentResult(`/front/pay/transfer/status/${2}/${res.data.orderId}`, 10, 2000);
                      } else if (res.err_msg === "requestMerchantTransfer:cancel") {
                        showToast("用户提现取消")
                      } else {
                        showToast("提现失败")
                      }
                    }
                  );
                } else {
                  alert("你的微信版本过低，请更新至最新版本。");
                }
              },
            });
          });
          // 在这里执行微信环境特有的逻辑
        } else {
          window.wx.config({
            debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: this.appid, // 必填，服务号的唯一标识
            nonceStr: nonceStr,
            signature: signature,
            timestamp: timeStamp,
            jsApiList: ["requestMerchantTransfer"], // 必填，需要使用的JS接口列表
          });
          window.wx.ready(function () {
            window.wx.checkJsApi({
              jsApiList: ["requestMerchantTransfer"],
              success: function (res) {
                if (res.checkResult["requestMerchantTransfer"]) {
                  WeixinJSBridge.invoke(
                    "requestMerchantTransfer",
                    {
                      mchId: res.data.mchId,
                      appId: res.data.appId,
                      package: res.data.packageInfo,
                    },
                    function (res) {
                      if (res.err_msg === "requestMerchantTransfer:ok") {
                        this.pollPaymentResult(`/front/pay/transfer/status/${2}/${res.data.orderId}`, 10, 2000);
                      } else if (res.err_msg === "requestMerchantTransfer:cancel") {
                        this.loading = false;
                        showToast("用户提现取消")
                      } else {
                        this.loading = false;
                        showToast("提现失败")
                      }
                    }
                  );
                } else {
                  alert("你的微信版本过低，请更新至最新版本。");
                }
              },
            });
          });
        }
      }
    },
    // 轮询查询支付结果
    pollPaymentResult(url, times, delay) {
      let count = 0;
      this.pollingTimer = setInterval(() => {
        this.checkPaymentResult(url).then(result => {
          if (result.code == 200) {
            if (result.data.status == 1) {
              this.loading = false;
              this.handlePaymentSuccess();
            } else if (result.data.status == 3) {
              this.loading = false;
              this.handlePaymentFailed();
            } else {
              // 未支付，继续轮询
              count++;
              if (count >= times) {
                clearInterval(this.pollingTimer);
                alert('支付结果未知，请检查订单状态');
              }
            }
          }

        }).catch(err => {
          count++;
          if (count >= times) {
            clearInterval(this.pollingTimer);
            alert('查询支付结果失败，请检查订单状态');
          }
        });
      }, delay);
    },

    checkPaymentResult(url) {
      return request.get(url)
    },

    // 处理支付成功
    handlePaymentSuccess() {
      this.showQrCodePopup = false;
      this.rechargeAmount = "";
      showToast("操作成功");

      // 清理轮询定时器
      if (this.pollingTimer) {
        clearTimeout(this.pollingTimer);
        this.pollingTimer = null;
      }

      // 更新用户余额
      this.$store.dispatch("user/getUserInfo").then((res) => {
        if (res.code == 200) {
          this.userInfo = res.data;
        }
      });
    },

    // 处理支付失败
    handlePaymentFailed() {
      this.showQrCodePopup = false;
      showToast("操作失败，请重新尝试");

      // 清理轮询定时器
      if (this.pollingTimer) {
        clearTimeout(this.pollingTimer);
        this.pollingTimer = null;
      }
    },

    async generateQRCode(text) {
      try {
        // 使用qrcode库生成二维码base64图片
        this.qrCodeImage = await QRCode.toDataURL(text, {
          width: 200,
          margin: 2,
          color: {
            dark: "#000000",
            light: "#ffffff",
          },
        });
        return true;
      } catch (error) {
        console.error("生成二维码失败:", error);
        showToast("生成二维码失败");
        return false;
      }
    },

    async alipayChargePay() {
      try {
        this.loading = true;
        const result = await request.post("/front/pay/create", {
          amount: parseFloat(this.rechargeAmount),
          payType: 2,
          payScene: 1,
        });
        if (result.code === 200) {
          const payFormPage = result.data.pageRedirection;
          this.handleAlipaySubmit(payFormPage);
        }
      } catch (error) {
        this.loading = false;
        showToast("支付失败，请重试!");
      }
    },

    handleAlipaySubmit(htmlForm) {
      // 创建一个临时容器
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlForm;

      // 获取表单元素
      const form = tempDiv.querySelector("form");
      if (form) {
        // 添加到页面并提交
        document.body.appendChild(form);
        form.submit();
      } else {
        showToast("支付失败!");
      }
    },

    //提现
    async confirmWithdraw() {
      //5分钟提现一次 控制频率
      const lastWithdrawTime = localStorage.getItem("lastWithdrawTime");
      const currentTime = new Date().getTime();
      if (lastWithdrawTime) {
        const timeDiff = currentTime - parseInt(lastWithdrawTime);
        const fiveMinutes = 5 * 60 * 1000; // 5分钟毫秒数

        if (timeDiff < fiveMinutes) {
          const remainingTime = Math.ceil((fiveMinutes - timeDiff) / 1000 / 60);
          showToast(`提现过于频繁，请${remainingTime}分钟后再试`);
          return;
        }
      }

      if (!this.withdrawAmount || this.withdrawAmount < 10) {
        showToast("最低提现金额为10 ");
        return;
      }
      const accountBalance = this.userInfo.accountBalance;
      const tranAmount = parseFloat(this.withdrawAmount);
      if (tranAmount > accountBalance) {
        showToast(
          "提现金额大于可用金额，当前可提现最大金额为:" + accountBalance
        );
        return;
      }
      if (this.payChecked === "1") {
        if (!this.withdrawAccount) {
          showToast("请输入提现账户");
          return;
        }
      }
      if (!this.withdrawName) {
        showToast("请输入提现真实姓名");
        return;
      }
      showDialog({
        title: "确认提现",
        message: `确认提现 ${this.withdrawAmount}元吗？`,
        showCancelButton: true,
      }).then(async () => {
        try {
          if (this.payChecked === "1") {
            if (this.isInWeixin) {
              showToast("请在浏览器内打开网页支付");
              return;
            }
            this.loading = true;
            this.loadingText = "正在跳转支付宝页面充值...";
            await this.aliPayWithdraw();
          } else {
            if (!this.isInWeixin) {
              showToast("请在微信内打开网页支付");
              return;
            }
            this.loading = true;
            this.loadingText = "正在跳转微信页面充值...";
            if (this.userInfo.openId) {
              this.processWechatTiXIAN({
                openid: this.userInfo.openId,
                amount: this.withdrawAmount, 
                realName: this.withdrawName
              })
            } else {
              this.onBridgeReady();
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false;
          this.showWithdrawPopup = false;
          // 提现后记录时间
          localStorage.setItem("lastWithdrawTime", currentTime.toString());
        }
      });
    },

    async aliPayWithdraw() {
      try {
        const result = await request.post("/front/pay/transfer", {
          amount: parseFloat(this.withdrawAmount),
          alipayAccount: this.withdrawAccount,
          realName: this.withdrawName,
          payType: 2
        });
        if (result.code === 200) {
          this.pollPaymentResult(`/front/pay/transfer/status/${2}/${result.data}`)
        } else {
          this.loading = false
          showToast(`提现失败：${result.msg}`);
        }
      } catch (error) {
        showToast("提现失败，请咨询客服!");
      }
    },
    async wechatWithdraw() {
      this.onBridgeReady();
    },
    beforeDestroy() {
      // 组件销毁前清理定时器
      if (this.pollingTimer) {
        clearTimeout(this.pollingTimer);
        this.pollingTimer = null;
      }
    },
    /**
     * 微信JS-SDK签名生成函数
     * @param {string} jsapi_ticket - 有效的jsapi_ticket
     * @param {string} noncestr - 随机字符串
     * @param {string} timestamp - 时间戳
     * @param {string} url - 当前网页URL（不包含#及其后面部分）
     * @returns {string} SHA1加密后的签名
     */
    generateWechatSignature(jsapi_ticket, noncestr, timestamp, url) {
      // 参数验证
      if (!jsapi_ticket || !noncestr || !timestamp || !url) {
        throw new Error("所有参数均为必填项");
      }

      // 构建参数对象（注意：参数名必须为小写）
      const params = {
        jsapi_ticket: jsapi_ticket,
        noncestr: noncestr,
        timestamp: timestamp.toString(),
        url: url.split("#")[0], // 移除#及其后面部分
      };

      // 按照字段名的ASCII码从小到大排序（字典序）
      const sortedKeys = Object.keys(params).sort();

      // 使用URL键值对格式拼接字符串
      const string1 = sortedKeys
        .map((key) => {
          return `${key}=${params[key]}`;
        })
        .join("&");

      // 对string1进行SHA1加密
      const signature = CryptoJS.SHA1(string1).toString();
      return signature;
    },
  },
};
</script>

<style scoped>
.wallet-container {
  background-color: #f7f8fa;
  min-height: 100vh;
}

/* 余额卡片 */
.balance-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  margin: 16px;
  padding: 24px;
  border-radius: 16px;
  color: white;
  box-shadow: 0 8px 32px rgba(102, 126, 234, 0.3);
}

.balance-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.balance-label {
  margin: 0 0 8px 0;
  font-size: 14px;
  opacity: 0.8;
}

.balance-amount {
  margin: 0;
  font-size: 32px;
  font-weight: bold;
}

.eye-icon {
  font-size: 20px;
  opacity: 0.8;
  cursor: pointer;
}

.balance-details {
  display: flex;
  justify-content: space-between;
}

.balance-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.balance-item .label {
  font-size: 12px;
  opacity: 0.8;
  margin-bottom: 4px;
}

.balance-item .amount {
  font-size: 16px;
  font-weight: 600;
}

/* 快捷操作 */
.quick-actions {
  background: white;
  margin: 16px;
  border-radius: 12px;
  padding: 16px 0;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

/* 交易记录 */
.transaction-section {
  background: white;
  margin: 16px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 16px 0;
}

.section-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.transaction-list {
  max-height: 400px;
  overflow-y: auto;
}

.income-amount {
  color: #07c160 !important;
}

.expense-amount {
  color: #ee0a24 !important;
}

/* 弹窗样式 */
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #ebedf0;
}

.popup-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.recharge-content,
.withdraw-content {
  padding: 20px;
}

.amount-options {
  display: flex;
  gap: 8px;
  margin-top: 16px;
  flex-wrap: wrap;
  margin-left: 15px;
}

.withdraw-tips {
  background: #f7f8fa;
  padding: 12px;
  border-radius: 8px;
  margin-top: 16px;
}

.withdraw-tips p {
  margin: 4px 0;
  font-size: 12px;
  color: #646566;
}

/* 标签页样式 */
:deep(.van-tabs__nav) {
  padding: 0 16px;
}

:deep(.van-tab) {
  flex: none;
  padding: 0 16px;
}

:deep(.cell-title) {
  font-size: 12px !important;
  width: 100%;
}

:deep(.van-cell__value) {
  flex: none;
}

/* 二维码弹窗样式 */
.qrcode-content {
  padding: 20px;
  text-align: center;
}

.qrcode-container {
  margin: 20px 0;
}

.qrcode-container img {
  border: 1px solid #eee;
  padding: 15px;
  margin-bottom: 15px;
  background: white;
  border-radius: 8px;
}

.qrcode-container .amount {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin: 10px 0;
}

.withdraw-container {
  padding: 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.withdraw-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header-title {
  font-size: 16px;
  font-weight: 500;
}

.payment-method {
  background: #fff;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 16px;
}

.method-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.method-name {
  flex: 1;
  font-size: 14px;
}

.account-input,
.amount-input {
  background: #fff;
  border-radius: 8px;
  padding-left: 12px;
  padding-right: 12px;
}

.input-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.amount-field {
  display: flex;
  align-items: center;
}

.currency {
  font-size: 20px;
  margin-right: 4px;
}

.balance-info {
  font-size: 12px;
  /* color: #999; */
  margin-top: 8px;
}

.voucher-section {
  margin: 16px 0;
}

.withdraw-notice {
  padding: 16px;
  background: #f7f8fa;
  border-radius: 8px;
}

.notice-item {
  font-size: 12px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 8px;
}

.submit-button {
  margin-top: auto;
  padding: 16px 0;
}

.recharge-container {
  padding: 16px;
}

.recharge-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header-title {
  font-size: 16px;
  font-weight: bold;
}

.amount-input {
  margin: 20px 0;
}

.amount-field {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding: 10px 0;
}

.currency {
  font-size: 20px;
  margin-right: 8px;
}

.balance-info {
  font-size: 14px;
  margin-top: 8px;
}

.amount-options {
  display: flex;
  gap: 10px;
  margin: 20px 0;
}

.amount-options .van-button {
  flex: 1;
  border-radius: 4px;
}

.recharge-notice {
  margin: 20px 0;
  padding: 12px;
  background-color: #f8f8f8;
  border-radius: 8px;
}

.notice-title {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 8px;
}

.wechat-pay-code {
  display: flex;
  justify-content: center;
  align-items: center;
}

.wechat-pay-code span {
  font-size: 18px;
  color: #000;
  padding-right: 20px;
}
</style>
